import { useState } from 'react';

import { UserActionJsonSchema } from 'pages/UserActions/components/UserActionJsonSchema/UserActionJsonSchema';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useShowController } from 'react-admin';
import { Button } from 'shared/mui/Buttons';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { UserAction } from 'types/embedded/userAction';

import { UserActionsShowChipFields } from './UserActionsShowChipFields';
import { UserActionsShowTable } from './UserActionsShowTable';

export const UserActionsShow: React.FC = () => {
  const translate = useTypedTranslate();

  const { record } = useShowController<UserAction>();
  const [open, setOpen] = useState(false);

  return (
    <ShowPage
      listName={translate('app.userActions.titleText')}
      rightActionsSlot={
        <Button
          label={translate('app.userActions.jsonSchema')}
          onClick={() => setOpen(true)}
          variant="outlined"
        />
      }
      title={translate('app.userActions.details')}
    >
      <UserActionsShowChipFields />
      <UserActionsShowTable />
      <UserActionJsonSchema onClose={() => setOpen(false)} open={open} record={record} />
    </ShowPage>
  );
};
